import qs from 'qs';

/**
 * 处理上报header中的地址，防止 header size 过大 报错431
 * @param href string访问地址
 * @returns {string} 访问地址
 */
export default function cutParamsInUrl(href: string): string {
  if (!href) return '';
  try {
    const location = new URL(href);
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    for (const k in query) {
      if (typeof query[k] === 'string') {
        query[k] = query[k]?.substring(0, 100);
      }
    }
    location.search = qs.stringify(query);
    return location.href;
  } catch (error) {
    console.log(error);
    return href;
  }
};
